export default __webpack_public_path__ + "static/media/Kerala_1.517b08c4.png";